<template>
  <div class="container">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <!--        <link rel="stylesheet" type="text/css" href="https://www.tssgroup.com.cn/style/css/font-awesome-4.7.0/css/font-awesome.css"/>-->
    <link rel="stylesheet" href="https://www.tssgroup.com.cn/style/css/qs.css?v=192" />
    <link rel="stylesheet" href="https://www.tssgroup.com.cn/style/css/ndnav02.css">
    <link rel="stylesheet" href="https://www.tssgroup.com.cn/style/css/qs-h5.css?v=91" />
    <!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/jquery.js" ></script>-->
    <!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/adaptive-version2.js" ></script>-->
    <!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/ndnav.js" ></script>-->
    <!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/exif.js"></script>-->
    <div class="header">
      <div class="center-pc-nav clearfix">
        <a href="https://www.tssgroup.com.cn/" class="logo"><img src="https://www.tssgroup.com.cn/style/images/logo1.svg" type="image/svg+xml"></a>
        <div class="pc-nav">
          <dd><a href="https://www.tssgroup.com.cn/about-us/group/" class="pc-n-a" id="pc-ts-1">走进青山</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/about-us/group/">集团简介</a>
              <a href="https://www.tssgroup.com.cn/about-us/honor/">集团荣誉</a>
              <a href="https://www.tssgroup.com.cn/about-us/video/">影像集锦</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/global/steel/" class="pc-n-a" id="pc-ts-2">全球业务</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/global/steel/">不锈钢制造</a>
              <a href="https://www.tssgroup.com.cn/global2new/">新能源产业链</a>
              <a href="https://www.tssgroup.com.cn/global/innovation/">创新与发展</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/peplo/duty1/" class="pc-n-a" id="pc-ts-3">社会责任</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/peplo/duty1/">生态环保</a>
              <a href="https://www.tssgroup.com.cn/peplo/duty2/">慈善公益</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/ts-news/news1/" class="pc-n-a" id="pc-ts-4">资讯中心</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/ts-news/news1/">企业动态</a>
              <a href="https://www.tssgroup.com.cn/ts-news/news2-1/">行业新闻</a>
              <a href="https://www.tssgroup.com.cn/ts-news/news2/">媒体聚焦</a>
              <a href="https://www.tssgroup.com.cn/ts-news/news3/">活动剪影</a>
            </div>
          </dd>
          <dd><a  class="pc-n-a" id="pc-ts-4">廉洁青山</a>
            <div class="item">
              <a href="https://jubao.tssgroup.com.cn/start/#/news_web">廉洁文化</a>
              <a href="https://jubao.tssgroup.com.cn/start/#/borad_web">曝光台</a>
              <a href="https://jubao.tssgroup.com.cn/start">我要举报</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/job/join1/" class="pc-n-a" id="pc-ts-5">加入我们</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/job/join1/">职业发展</a>
              <a href="https://www.tssgroup.com.cn/job/join2/">诚聘英才</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/contact/contact-us/" class="pc-n-a" id="pc-ts-6">联系我们</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/contact/contact-us/">联系方式</a>
              <a href="https://www.tssgroup.com.cn/contact/line/">互动留言</a>
            </div>
          </dd>
        </div>
        <div class="pc-right">
          <a href="#"><div class="fa fa-search"></div></a>
          <a href="https://mail.tssgroup.com.cn/accounts/login?system=mail" target="_blank">登录</a>
          <a href="https://www.tssgroup.com.cn/en/">EN</a>
        </div>

      </div>
    </div>
    <div class="inwarp">
      <!--in-banner-->
      <div class="in-banner">
        <img src="https://www.tssgroup.com.cn/style/images/news1_01.jpg?v=1" />
        <div class="text incont">
          <p>廉洁青山</p>
          <h3>廉洁新闻</h3>
        </div>
        <img src="https://www.tssgroup.com.cn/style/images/jj.svg" class="in-bot" />
      </div>

      <!--mbx-->
      <div class="mbx" style="text-align: left">
        <a href="https://www.tssgroup.com.cn/">首页</a><i>/</i><a href="https://jubao.tssgroup.com.cn/start/#/news_web">廉洁青山</a><i>/</i><a href="https://jubao.tssgroup.com.cn/start/#/news_web">廉洁新闻</a>
      </div>

      <!--news1-->
      <div class="news1 news2 incont clearfix">
        <div style="width: 160px;">
          <h3 class="l-text" aos="fade-up" v-if="model==1">廉洁新闻</h3>
          <h3 class="l-text"  v-if="model==2" style="color: gray; cursor:pointer;"  @click="changeModel(1)">廉洁新闻</h3>
          <!--          <br><br><br>-->
                    <p class="" style="width: 160px;
                                        box-sizing: border-box;
                                        font-size: 24px;
                                        color: gray;
                                        padding-top: 20px;
                                        float: left; cursor:pointer;
                                        " v-if="model==1" @click="changeModel(2)">廉洁文档</p>
                    <h3 class="" style="width: 160px;
                                        box-sizing: border-box;
                                        font-size: 24px;
                                        color: #fdd000;
                                        padding-top: 20px;
                                        float: left;" v-if="model==2">廉洁文档</h3>
        </div>
        <div class="min" v-if="model==1" style="margin-top: -52px;">
          <div v-for="(item,index) in listData" style="margin-bottom: 50px" >
            <!--            <a href="https://www.tssgroup.com.cn/%e9%9d%92%e5%b1%b1%e9%92%a2%e7%ae%a1%e4%b8%be%e5%8a%9e%e6%b3%95%e5%be%8b%e7%9f%a5%e8%af%86%e5%9f%b9%e8%ae%ad/" class="item" aos="fade-up">-->
            <a @click="openDetail(item.id)" class="item" aos="fade-up">
              <!-- <div class="imgbox" style="height: 200px;"><img src="item.banner" /></div> -->
              <div class="imgbox"><img :src="item.banner" /></div>
              <div class="text">
                <p>{{ item.releaseTime }}</p>
                <h3>{{ item.title }}</h3>
                <h4>{{ item.htmlContentTag }}</h4>
                <!--<font><div class="fa fa-angle-right"></div>了解更多</font>-->
              </div>
            </a>
          </div>
          <div class="fy" style="margin-top: 50px" v-if="total>6">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="size"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="min"  v-if="model==2" style="margin-top: -52px;">
          <el-tabs v-model="activeName" type="card" class="myTabs">
            <el-tab-pane label="廉洁制度" name="first">
              <el-table
                :data="tableData"
                v-if="activeName=='first'"
                strip>
                <el-table-column
                  prop="index"
                  label="序号"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="文件名称"
                >
                  <template slot-scope="scope">
    <!--                <el-button type="text" size="small" @click="handleDownload(scope.row)" style="user-select: unset">{{  scope.row.name }}</el-button>-->
                    <a style="color:#409EFF;text-decoration:none" :href="scope.row.url">{{ scope.row.name }}</a>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="date"
                  label="上传日期"
                  width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="廉洁表格" name="second">
              <el-table
                :data="tableData1"
                v-if="activeName=='second'"
                stripe>
                <el-table-column
                  prop="index"
                  label="序号"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="文件名称"
                >
                  <template slot-scope="scope">
                    <!--                <el-button type="text" size="small" @click="handleDownload(scope.row)" style="user-select: unset">{{  scope.row.name }}</el-button>-->
                    <a style="color:#409EFF;text-decoration:none" :href="scope.row.url">{{ scope.row.name }}</a>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="date"
                  label="上传日期"
                  width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="center">

        <div class="top">
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/about-us/group/">走进青山</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/about-us/group/"><span></span>集团简介</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/about-us/honor/"><span></span>集团荣誉</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/about-us/video/"><span></span>影像集锦</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/global/steel/">全球业务</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/global/steel/"><span></span>不锈钢制造</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/global2new/"><span></span>新能源产业链</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/global/innovation/"><span></span>创新与发展</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/duty1/"><span></span>社会责任</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/duty1/"><span></span>生态环保</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/duty2/"><span></span>慈善公益</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/ts-news/news1/">资讯中心</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news1/"><span></span>企业动态</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news2-1/"><span></span>行业新闻</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news2/"><span></span>媒体聚焦</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news3/"><span></span>活动剪影</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/job/join1/">加入我们</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/job/join1/"><span></span>职业发展</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/job/join2/"><span></span>诚聘英才</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/contact/contact-us/">联系我们</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/contact/contact-us/"><span></span>联系方式</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/contact/line/"><span></span>互动留言</a></h4>
          </dd>
          <!--          <dt>-->
          <!--            <img src="/style/images/202004011521.jpg">-->
          <!--            <span><i>微信扫码</i>关注青山微信公众号</span>-->
          <!--          </dd>-->
        </div>

        <div class="bottom">
          <h3>©  版权所有：青山控股集团有限公司<a href="https://beian.miit.gov.cn" target="blank">浙ICP备11014192号-1</a>

            <strong>
              <span>友情链接</span><div class="fa fa-caret-down"></div>
              <font>
                <a target="_blank" href="http://www.tsingtuo.com/">青拓集团有限公司</a>
                <a target="_blank" href="http://www.etsingshan.com/">永青集团有限公司</a>
                <a target="_blank" href="http://www.decent-china.com/">上海鼎信投资(集团)有限公司</a>
                <a target="_blank" href="http://www.chinarept.com/">永青科技股份有限公司（瑞浦能源）</a>
                <a target="_blank" href="http://www.j-eray.com/index_cn.aspx">广东吉瑞科技集团</a>
              </font>
            </strong>

          </h3>
          <h4>
            <a href="https://www.tssgroup.com.cn/sitemap/" style=" ">Sitemap</a>

            <a href="http://www.songyi.net" target="_blank" style="opacity: 0;font-size:0;">Powered by SE</a>
          </h4>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import request from '@/api/request'
// import './css/news.css';
export default {
  name: "news",
  data(){
    return{
      current:1,
      total:0,
      size:6,
      listData:[],
      model:1,
      tableData: [
      //   {
      //   date: '2023-09-05',
      //   index: '1',
      //   name:"主动申报财物表.docx",
      //   url:"./static/主动申报财物表.docx"
      // }
      ],
      tableData1: [{
        date: '2023-09-05',
        index: '1',
        name:"主动申报财物表.docx",
        url:"./static/主动申报财物表.docx"
      }],
      activeName:"first"
    }
  },
  created() {
    this.getDataList();
  },
  methods:{
    handleCurrentChange(val) {
      this.current=val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    //获取数据
    getDataList(){
      let httpURL = `/news/list_pub`; //目标地址后接的详细地址
      let formData = new FormData();
      formData.append('pageSize', this.size);
      formData.append('pageNum', this.current);
      // formData.append('orderByColumn','createTime');
      // formData.append('isAsc','desc');
      let that=this;
      request.post(httpURL,formData).then(function (res) {
        // console.log(res);
        if (res.code == "0") {
          // console.log(res);
          // that.tableData=res.rows;
          let resData=res.rows;
          for(let i=0;i<resData.length;i++){
            resData[i].releaseTime=(resData[i].releaseTime).substring(0,10);
            resData[i].htmlContentTag=(resData[i].htmlContentTag).replace(/&nbsp;/gi, "");
          }
          that.listData=resData;
          // console.log(resData);
          that.total=res.total;
        }
      })
    },
    //新闻详情
    openDetail(id){
      this.$router.push({
        path: `/newsDetail_web/${id}`
      })
    },
    //
    changeModel(model){
      this.model=model;
    },
    // handleDownload(row){
    //   let url=row.url;
    //   console.log(url)
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', 'file.pdf');
    //   document.body.appendChild(link);
    //   link.click();
    // }
  }
}
</script>

<style>
.myTabs .el-tabs__item:hover {
  color: #fdd000;
  /*background-color: orange ;*/
}
.myTabs .el-tabs__item.is-active {
  color: #fdd000;
  /*background-color: orange;*/
}
</style>

<style scoped>
.container{
  position : absolute;
  top:0;
  left: 0;
}

.header {
  background-color: rgba(67,67,67,0.95);
}

/deep/.el-pagination span{
  background: #574225;
  border: 1px solid #fdd000;
  color: #FFFFFF;
  padding: 0 5px;
  line-height: 2;
  border-radius: 4px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled){
  background-color: #FFFFFF;
  color: #000;
  border-radius: 90px;
  /*size: 60px;*/
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fdd000;
  color: #fff;
}

/deep/.myTabs .el-tabs__item:hover {
  color: #fdd000;
  /*background-color: orange ;*/
}
/deep/.myTabs .el-tabs__item.is-active {
  color: #fdd000;
  /*background-color: orange;*/
}
</style>



// WEBPACK FOOTER //
// src/pages/web/news.vue